import { SubscriptionPeriod } from '@anm/api/modules/subscription';
import Badge from '@anm/components/Badge';
import { ANNUAL, MONTHLY } from '@anm/constants/subscription';
import noop from 'lodash/fp/noop';
import { useCallback, FC } from 'react';
import { Sale } from 'types/pricing';

import Wrapper, { ButtonWrapper, Container } from './Wrapper';

type OnChange = (periodName: SubscriptionPeriod) => void;
export type PeriodSwitcherProps = {
  isAnnual: boolean;
  seasonalDiscount?: Sale;
  onChange?: OnChange;
};

const PeriodSwitcher: FC<PeriodSwitcherProps> = ({ isAnnual, seasonalDiscount, onChange = noop as OnChange }) => {
  const discount = (seasonalDiscount?.annual?.discount || 0.2) * 100;

  const changeToAnnual = useCallback(() => onChange(ANNUAL), []);
  const changeToMonthly = useCallback(() => onChange(MONTHLY), []);

  return (
    <Wrapper>
      <Container>
        <ButtonWrapper size="big" variant="gray" isActive={isAnnual} onClick={changeToAnnual}>
          Annually <Badge variant="yellow">-{discount}%</Badge>
        </ButtonWrapper>
        <ButtonWrapper size="big" variant="gray" isActive={!isAnnual} onClick={changeToMonthly}>
          Monthly
        </ButtonWrapper>
      </Container>
    </Wrapper>
  );
};

export default PeriodSwitcher;
